module.exports = __webpack_public_path__ + "img/lsmy-ai-robot.cbd772d3.png";